import { SlideType } from '../enums';
import { QuestionTypes } from '../enums';
import { QuestionMultipleAnswers } from '../zod/slideTypes/questionSlideSchema';
import { Slide } from '../zod/slideTypes/slideSchema';

export default function isSlideQusestionMultipleAnswerSlide(
  slide: Slide
): slide is QuestionMultipleAnswers {
  return isTypeOfSlideMultipleAnswerQuestionType(slide.type);
}

function isTypeOfSlideMultipleAnswerQuestionType(type: SlideType): type is QuestionTypes {
  return type === SlideType.QUESTION_MULTIPLE || type === SlideType.QUESTION_MULTIPLE_ORDERED;
}
